module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#logic",
      toString: function () {
        return this.url;
      }
    }